import type { ReactNode } from "react";
import styles from "@styles/site.module.css";

type TerminalCardProps = {
  children: ReactNode;
  title?: string;
};

export function TerminalCard({ children, title }: TerminalCardProps) {
  return (
    <div className={styles.terminal}>
      {title && <div className={styles.terminalBar}>{title}</div>}
      <div className={styles.terminalBody}>{children}</div>
    </div>
  );
}
